import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

function formatErr(detail) {
  if (detail == null) return "Errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export const Login = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative z-10 pt-20">
      <div className="w-full max-w-md bg-[#121212] border border-white/10 rounded-2xl p-8">
        <h1 className="font-display text-3xl text-white mb-2">Area riservata</h1>
        <p className="text-zinc-400 text-sm mb-8">Accedi per gestire i contenuti del sito.</p>
        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <label className="text-sm text-zinc-400 mb-2 block">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" className="w-full bg-[#0A0A0A] border border-[#27272A] rounded-md px-4 py-3 outline-none focus:border-[#C19A5B]" />
          </div>
          <div>
            <label className="text-sm text-zinc-400 mb-2 block">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" className="w-full bg-[#0A0A0A] border border-[#27272A] rounded-md px-4 py-3 outline-none focus:border-[#C19A5B]" />
          </div>
          <button type="submit" disabled={busy} data-testid="login-submit" className="w-full rounded-full bg-[#C19A5B] text-black font-semibold px-6 py-3.5 hover:bg-[#D4AF37] transition-colors disabled:opacity-60">
            {busy ? "Accesso…" : "Accedi"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
